import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  FOOTBALL_MY_CLUB_SLUG,
  MLB_MY_CLUB_SLUG,
  NBA_MY_CLUB_SLUG,
} from '@sorare/core/src/constants/__generated__/routes';

import { Block } from '../Block';
import { SportClub } from './SportClub';
import { OtherClubs_user } from './__generated__/index.graphql';
import ballBadge from './assets/ball-badge.svg';

type Props = {
  user: OtherClubs_user;
};

export const OtherClubs = ({ user }: Props) => {
  return (
    <Block
      title={
        <FormattedMessage
          id="Profile.OtherClubs.otherClubs"
          defaultMessage="Other clubs"
        />
      }
      icon={<img src={ballBadge} alt="Clubs" />}
    >
      <SportClub
        onboarded={user.footballUserProfile?.onboarded}
        sport={Sport.FOOTBALL}
        clubName={user.footballUserProfile?.clubName}
        shieldUrl={user.footballUserProfile?.clubBadge?.pictureUrl}
        to={generatePath(FOOTBALL_MY_CLUB_SLUG, { slug: user.slug })}
      />
      <SportClub
        onboarded={user.nbaUserProfile?.onboarded}
        sport={Sport.NBA}
        shieldUrl={user.nbaUserProfile?.shieldUrl}
        clubName={user.nbaUserProfile?.clubName}
        to={generatePath(NBA_MY_CLUB_SLUG, { slug: user.slug })}
      />
      <SportClub
        onboarded={user.baseballUserProfile?.onboarded}
        sport={Sport.BASEBALL}
        shieldUrl={user.baseballUserProfile?.shieldUrl}
        clubName={user.baseballUserProfile?.clubName}
        to={generatePath(MLB_MY_CLUB_SLUG, { slug: user.slug })}
      />
    </Block>
  );
};

OtherClubs.fragments = {
  user: gql`
    fragment OtherClubs_user on User {
      id
      slug
      footballUserProfile {
        id
        clubName
        clubBadge {
          id
          pictureUrl
          name
        }
        onboarded
      }
      nbaUserProfile {
        id
        clubName
        shieldUrl
        onboarded
      }
      baseballUserProfile {
        id
        clubName
        shieldUrl
        onboarded
      }
    }
  ` as TypedDocumentNode<OtherClubs_user>,
};
